import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import {configureSentryScope} from 'web-app/shared/sentry-setup';

import {APIErrorCode} from './types';

export const INVALID_PASSWORD_ERROR_CODE = 1441363022;
export const EMAIL_DOES_NOT_EXIST = 1441363021;

export default class LoginsApi {
    static logOut(deviceToken, appKind, wasAutoLogout) {
        // We attempt to track automated logouts by adding the non-interferring query param of "auto=1"
        return RESTClient.postAuthenticated(
            `v2/logins/logout${wasAutoLogout ? '?auto=1' : ''}`,
            {
                deviceToken,
                appKind,
            },
            {
                // Don't throw error if called by auto logout
                ignoredErrors: wasAutoLogout ? [APIErrorCode.SESSION_EXPIRED] : undefined,
            },
        )
            .then(() => {
                configureSentryScope(scope => {
                    scope.setUser();
                });
            })
            .catch(error => {
                if (wasAutoLogout && error?.responseData?.errorCode === APIErrorCode.SESSION_EXPIRED) {
                    // If the session has expired at this point there's no need to warn the user.
                    // Silently hide the error and proceed.
                    return;
                }
                // Otherwise actually throw the error
                throw error;
            });
    }

    static assignRole(roleId, famlyId, targetId, overrideTargetType) {
        return RESTClient.postAuthenticated(`v2/roles/${roleId}/assign`, {
            assignee: famlyId,
            targetId,
            overrideTargetType,
        });
    }

    static unassignRole(roleId, loginId, targetId, overrideTargetType) {
        return RESTClient.deleteAuthenticated(`v2/logins/${loginId}/roles/${roleId}/targets/${targetId}`, {
            overrideTargetType,
        });
    }
}
